import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import SwitchToggle from "../../components/SwitchToggle";

const GeoFencing = () => {

  const navigate = useNavigate();
  const [rows] = useState([
    {
      id: 1,
      name: "Mall Area",
      availability: "Always Available",
      providers: "22",
      date: "01 March 2025"
    },
    {
      id: 2,
      name: "Downtown",
      availability: "Always Available",
      providers: "5",
      date: "01 March 2025"
    },
    {
      id: 3,
      name: "Airport Zone",
      availability: "Custom Schedule",
      providers: "10",
      date: "01 March 2025"
    }
  ]);

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Geofencing</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Geofencing
        </p>
      </div>

      <div className="cards">

        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..." />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/geofencing/add")} ><AddIcon /> Add Geofencing</Button>
          </div>
        </div>
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Geo Fencing Name</TableCell>
                <TableCell>Availability</TableCell>
                <TableCell>Providers Assigned</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.availability}</TableCell>
                  <TableCell>{row.providers}</TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell><SwitchToggle /></TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <IconButton onClick={() => navigate("/geofencing/add")}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                      </Box>
                      <Box>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </Box>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>


      </div>
    </>

  );
};

export default GeoFencing;
